angular.module('shbdeployer.docker').controller('NodeAvailabilitySelectController', [
  function NodeAvailabilitySelectController() {
    this.onChange = onChange;

    function onChange() {
      this.onSave({ availability: this.availability });
    }
  },
]);
